
<template>
  <div
    :class="['sound-container', expandedClass, mobileClass]"
    @mouseover="mouseEntered()"
    @mouseleave="mouseLeft()"
    @click="tapped()"
    id="sounds"
  >
    <div class="sound">
      <div class="sound-svg" @click="toggleSoundscape">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <g id="icon-tunes" opacity="0.5">
            <g id="sound-note">
              <path
                d="M8.26266 20.3671C8.26266 22.3726 6.63686 23.9984 4.63133 23.9984C2.6258 23.9984 1 22.3726 1 20.3671C1 18.3616 2.6258 16.7358 4.63133 16.7358C6.63686 16.7358 8.26266 18.3616 8.26266 20.3671Z"
                fill="black"
              />
              <path
                d="M22.1828 17.9462C22.1828 19.9517 20.557 21.5775 18.5514 21.5775C16.5459 21.5775 14.9201 19.9517 14.9201 17.9462C14.9201 15.9407 16.5459 14.3149 18.5514 14.3149C20.557 14.3149 22.1828 15.9407 22.1828 17.9462Z"
                fill="black"
              />
              <path
                d="M22.1828 2.43913C22.1828 1.68769 21.5053 1.11783 20.7649 1.24658L9.26571 3.24645C8.68592 3.34728 8.26266 3.8505 8.26266 4.43899V5.84178L22.1828 3.42089V2.43913Z"
                fill="black"
              />
              <path
                d="M8.26266 20.3671C8.26266 22.3726 6.63686 23.9984 4.63133 23.9984C2.6258 23.9984 1 22.3726 1 20.3671C1 18.3616 2.6258 16.7358 4.63133 16.7358C6.63686 16.7358 8.26266 18.3616 8.26266 20.3671ZM8.26266 20.3671V5.84178M22.1828 17.9462C22.1828 19.9517 20.557 21.5775 18.5514 21.5775C16.5459 21.5775 14.9201 19.9517 14.9201 17.9462C14.9201 15.9407 16.5459 14.3149 18.5514 14.3149C20.557 14.3149 22.1828 15.9407 22.1828 17.9462ZM22.1828 17.9462V3.42089M22.1828 3.42089V2.43913C22.1828 1.68769 21.5053 1.11783 20.7649 1.24658L9.26571 3.24645C8.68592 3.34728 8.26266 3.8505 8.26266 4.43899V5.84178M22.1828 3.42089L8.26266 5.84178"
                stroke="black"
                stroke-width="1.81567"
              />
            </g>
            <g id="cross-bar" v-if="soundscapeLabel == 'OFF'">
              <path
                id="Vector 3049"
                d="M2.51953 6.70703L26.4662 24.2728"
                stroke="#FEF9F1"
                stroke-width="3"
              />
              <path
                id="Vector 3048"
                d="M2.21875 4.73047L26.1654 22.2963"
                stroke="black"
                stroke-width="1.81567"
              />
            </g>
          </g>
        </svg>
        <!-- [{{ soundscapeLabel }}] Soundscape -->
      </div>
      <!-- <button @click="toggleEffects">[{{ effectsLabel }}] Effects</button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "SoundSettings",
  data() {
    return {
      expanded: false,
      mobileBreakpoint: 480,
    };
  },
  computed: {
    soundscapeLabel() {
      console.log("sound scape muted?", this.$store.state.soundscapeMuted);
      return this.$store.state.soundscapeMuted ? "OFF" : "ON";
    },
    effectsLabel() {
      return this.$store.state.effectsMuted ? "OFF" : "ON";
    },
    expandedClass() {
      if (this.expanded == true) {
        return "sound--is-expanded";
      } else {
        return "";
      }
    },
    isMobile() {
      return window.innerWidth <= this.mobileBreakpoint ? true : false;
    },
    mobileClass() {
      return window.innerWidth <= this.mobileBreakpoint
        ? "sound-is--mobile"
        : "";
    },
  },
  methods: {
    toggleSoundscape() {
      this.$store.dispatch("toggleSoundscape");
    },
    toggleEffects() {
      this.$store.dispatch("toggleEffects");
    },
    tapped() {
      if (!this.isMobile) {
        return;
      }

      if (this.isMobile && !this.expanded) {
        console.log("setting expanded to true");
        this.expanded = true;
      }
    },
    mouseLeft() {
      console.log("setting expanded to false");
      this.expanded = false;
    },
    mouseEntered() {
      if (this.isMobile) {
        return;
      }

      this.expanded = true;
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.sound-container {
  filter: drop-shadow(0px 4.38857px 14.2629px rgba(114, 74, 13, 0.25));
  position: absolute;
  top: calc(24px - 8px);
  left: calc(24px - 8px);
  /* height: 80px;
  width: 80px; */
  padding: 8px;
  z-index: 10000;
  border-radius: 200px;

  transition: all 350ms ease-in-out;
}

.sound {
  cursor: pointer;
}

.sound .sound-svg {
  filter: blur(0.06rem);
}
</style>
